import { InjectionToken } from '@angular/core';

export const AUTH_INTERCEPTOR_CONFIG_TOKEN = new InjectionToken<Partial<AuthInterceptorConfig>>(
  'AUTH_INTERCEPTOR_CONFIG_TOKEN'
);

export type AuthInterceptorConfig = {
  exceptionUrls: string[];
};
